import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { ProductService } from './product.service';
import { TableViewPopup } from 'src/app/import-table-maker/table-view-popup/table-view-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductEditPopup } from './product-edit-popup/product-edit-popup';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit, OnDestroy {
  user: User;
  dbPath: CollectionReference;

  requiredColumn = [{
    name: 'name',
    conversion: String
  }, {
    name: 'categories',
    conversion: Array
  }, {
    name: 'description',
    conversion: String
  }, {
    name: 'maxLimit',
    conversion: Number
  }, {
    name: 'price',
    conversion: Number,
  }, {
    name: 'productNumber',
    conversion: String,
  }, {
    name: 'threshold',
    conversion: Number,
  }, {
    name: 'type',
    conversion: String,
  },
  {
    name: 'category',
    conversion: String
  }];

  constructor(public auth: AuthService,
    private router: Router,
    private productService: ProductService,
    private dialog: MatDialog,
    private route: ActivatedRoute) {
    this.dbPath = this.productService.getProductPathRef()

  }

  ngOnInit() {
    this.auth.user$.subscribe(user => {
      this.user = user;
    });
  }

  onNewProduct() {

    this.dialog.open(ProductEditPopup, {
      disableClose: true,
      width: '750px',
      data: {}
    });
    // this.router.navigate(['new'], { relativeTo: this.route })
  }

  handleFileSelect(files: FileList) {
    console.log(files);
    if (files && files.length > 0) {
      let file: File = files.item(0);
      console.log(file.name);
      console.log(file.size);
      console.log(file.type);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv = reader.result;
        console.log(csv);
        this.csvJSON(csv)

      }
    }
  }


  csvJSON(csv) {
    let lines = csv.split("\n");

    let result = [];

    let headers = lines[0].split(";");

    for (let i = 1; i < lines.length; i++) {
      let obj = {};
      let currentline = lines[i].split(";");

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }

    //return result; //JavaScript object

  }

  ngOnDestroy() {
    this.productService.destroyService();
  }

  import() {
    const dialogRef = this.dialog.open(TableViewPopup, {
      disableClose: true,
      width: '1200px',
      // height: '750px',
      data: {
        dummyTemplate: this.productService.getProductDummyTemplate(),
        dbPath: null,
        requiredColumn: this.requiredColumn,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("Result", result);
      if (result)
        this.productService.uploadImportedData(result);
      console.log('The dialog was closed');
    });
  }
}
